/* global femcare */

femcare.shared = femcare.shared || {};

femcare.shared.dateFormat = {
    /**
     * Gets the current document locale from the html lang attribute.
     * @returns {string} Locale string
     */
    getLocale: function () {
        return document.documentElement.lang || 'en';
    },

    /**
     * Formats a date using the current locale.
     * @param {Date} date - Date to format
     * @param {Intl.DateTimeFormatOptions} options - Intl formatting options
     * @returns {string} Formatted date
     */
    format: function (date, options) {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }

        return new Intl.DateTimeFormat(this.getLocale(), options).format(date);
    },

    /**
     * Formats a month and year using the current locale.
     * @param {Date} date - Date to format
     * @returns {string} Formatted month and year
     */
    formatMonthYear: function (date) {
        return this.format(date, {
            month: 'long',
            year: 'numeric'
        });
    },

    /**
     * Formats a month and day using the current locale.
     * @param {Date} date - Date to format
     * @returns {string} Formatted month and day
     */
    formatDayMonth: function (date) {
        return this.format(date, {
            day: '2-digit',
            month: 'long'
        });
    },

    /**
     * Formats a full date with weekday using the current locale.
     * @param {Date} date - Date to format
     * @returns {string} Formatted date with weekday
     */
    formatWeekdayDayMonthYear: function (date) {
        return this.format(date, {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    },

    /**
     * Formats a full date without weekday using the current locale.
     * @param {Date} date - Date to format
     * @returns {string} Formatted full date
     */
    formatDayMonthYear: function (date) {
        return this.format(date, {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    }
};
